import { captureUtmToStorage, getStoredUtm } from './utm'

export type LeadPayload = {
  name: string
  contact: string
  revenue: string
  // budget — опциональный квалификатор проекта. Помогает
  // отсортировать «пришёл с 5 млн» от «пока не знаю» до созвона.
  budget?: string
  // task — опционально (с 2026-04-25). Раньше требовали min(10),
  // но это блокировало мотивированных лидов. Лучше пустой task +
  // телефон, чем форма не отправляется.
  task?: string
}

/**
 * Отправка заявки на Cloudflare Pages Function `/api/submit`,
 * которая в W3 проксирует её в Telegram Bot API + Google Sheets.
 *
 * W1: stub — fetch на endpoint, который ещё не реализован.
 * Форма работает локально в dev, но ждёт Pages Function на деплое.
 */
export async function submitLead(data: LeadPayload): Promise<void> {
  // На случай меток прямо в текущем URL — захват+перезапись, затем читаем
  // накопленное из localStorage (utm_* + партнёрский p, переживают навигацию).
  captureUtmToStorage()
  const body = {
    ...data,
    ...getStoredUtm(),
    submittedAt: new Date().toISOString(),
    page: typeof window !== 'undefined' ? window.location.href : '',
  }

  const res = await fetch('/api/submit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })

  if (!res.ok) {
    throw new Error(`submit failed: ${res.status}`)
  }
}
